const initialState = {
  list: [],
  usersLoading: false,
  usersError: null,
  rolesData: null,
  rolesLoading: false,
  rolesError: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_USERS_REQUEST':
      return { ...state, usersLoading: true, usersError: null };
    case 'GET_USERS_SUCCESS':
      return {
        ...state,
        usersLoading: false,
        list: action.payload.users || []
      };
    case 'GET_USERS_FAILURE':
      return { ...state, usersLoading: false, usersError: action.payload };
    case 'GET_USER_ROLES_REQUEST':
      return { ...state, rolesLoading: true, rolesError: null };
    case 'GET_USER_ROLES_SUCCESS':
      return {
        ...state,
        rolesLoading: false,
        rolesData: action.payload,
        rolesError: null
      };
    case 'GET_USER_ROLES_FAILURE':
      return { ...state, rolesLoading: false, rolesError: action.payload };
    case 'SET_USER_ROLES_REQUEST':
      return { ...state, rolesLoading: true, rolesError: null };
    case 'SET_USER_ROLES_SUCCESS':
      return { ...state, rolesLoading: false, rolesError: null };
    case 'SET_USER_ROLES_FAILURE':
      return { ...state, rolesLoading: false, rolesError: action.payload };
    case 'CLEAR_USER_ROLES':
      return {
        ...state,
        rolesData: null,
        rolesLoading: false,
        rolesError: null
      };
    default:
      return state;
  }
};
